import React from 'react';
import type { LscArchiveItem } from '../types';

export function isYouTubeArchive(archive: { embed_provider?: string | null }): boolean {
  return (archive.embed_provider || '').trim().toLowerCase() === 'youtube';
}

export function youtubeArchiveEmbedUrl(videoId: string): string {
  return `https://www.youtube.com/embed/${encodeURIComponent(videoId)}`;
}

export function youtubeWatchUrl(archive: Pick<LscArchiveItem, 'url' | 'provider_vod_id'>): string | null {
  const stored = archive.url?.trim();
  if (stored && stored.includes('youtube.com/')) return stored;
  const videoId = archive.provider_vod_id?.trim();
  if (!videoId) return null;
  return `https://www.youtube.com/watch?v=${encodeURIComponent(videoId)}`;
}

export function YouTubeArchiveFrame({
  videoId,
  title,
}: {
  videoId: string;
  title: string;
}) {
  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-lg border border-secondary-700 bg-black">
      <iframe
        src={youtubeArchiveEmbedUrl(videoId)}
        title={title}
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        className="absolute inset-0 h-full w-full"
        data-testid="youtube-archive-iframe"
      />
    </div>
  );
}
